import { CSSProperties } from "react";

import { CARD_PADDING, SCROLLBAR_RIGHT_OFFSET } from "../../constants";
import { getTopOffsetStyle } from "../../helpers";

type GetNavigationOffsetStyles = {
  isEngagementBarVisible: boolean;
  isSmallScreen: boolean;
  isFullSize: boolean;
  appLeftPadding: number;
  appRightPadding: number;
};

export const getNavigationOffsetStyles = ({
  isEngagementBarVisible,
  isSmallScreen,
  isFullSize,
  appLeftPadding,
  appRightPadding
}: GetNavigationOffsetStyles): CSSProperties => {
  const top = getTopOffsetStyle(isEngagementBarVisible, isSmallScreen);

  if (isSmallScreen && isFullSize) {
    return {
      top,
      borderRadius: 0,
      marginLeft: -appLeftPadding,
      paddingLeft: appLeftPadding + CARD_PADDING,
      width: "100vw",
      paddingRight: appRightPadding + CARD_PADDING + SCROLLBAR_RIGHT_OFFSET
    };
  }

  return { top };
};
